









































import {Component, Prop, Vue} from 'vue-property-decorator'
import {IsItem} from '../../models/IsItem'

@Component({
  components: {},
})
export default class ItemRow extends Vue {
  @Prop() item: IsItem
  @Prop() currentIndex: number

}

